<template>
  <div class="details_main">
    <div class="DataShowDetails_top">
      <div class="DataShowDetails_top_main">
        <svg
                @click="closeModel"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="menu-tab-stick-header-back-icon"
                tabindex="0"
        >
          <g fill="none" fill-rule="evenodd">
            <circle
                    cx="12"
                    cy="12"
                    r="11.5"
                    fill="#F5F5F5"
                    stroke="#E8E8E8"
            ></circle>
            <g
                    stroke="#999"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
            >
              <path
                      d="M4 8L0 4 4 0M1 4L10 4"
                      transform="translate(7 8)"
              ></path>
            </g>
          </g>
        </svg>
        <!-- <el-icon @click="closeModel" size="20px"><ArrowLeftBold /></el-icon> -->

        <span>隐私政策</span>
      </div>
    </div>
    <div class="DataShowDetails">
      <div class="DataShowDetails_content">
        <div class="DataShowDetails_Richtext">
          <div class="DataShowDetails_Richtext_title">
            {{ formData.systemPrivacyPolicyTitle }}
          </div>
          <div class="other_spanBox">
            <span v-if="formData.systemPrivacyPolicyPublicTime" class="other_spanBox_source_time">{{
                            formData.systemPrivacyPolicyPublicTime.substring(0, 16)
                        }}</span>
            <span class="DataShowDetails_classification_item">
                          {{ formData.systemTerminalUserType }}

                        </span>
          </div>
          <!-- 富文本 -->
          <div
                  class="DataShowDetails_rich"

                  v-html="formData.systemPrivacyPolicyContent"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { onMounted, reactive, ref, defineEmits, defineExpose } from 'vue';
import { requestNoToken } from '@/util/adminRequest.js'
import { useRouter, useRoute } from 'vue-router';

const route = useRoute();
// 返回上级调用参数
const router = useRouter();
// 表单ref
const formDataRef = ref(null)
// 返回上级调用参数
const emits = defineEmits(['childMethod'])

// 表单数据
const formData = reactive({
  systemPrivacyPolicyTitle: '',
  systemPrivacyPolicyContent:'',
  systemPrivacyPolicyPublicTime:'',
  systemPrivacyPolicyUpdateTime:''
})

// 显示数据
const showData = reactive({

})


//获取一个数据
const getOneData = function () {
  console.log(11)
  requestNoToken({
      url: '/Api/baseSystem/SystemModule/SystemPrivacyPolicy/GetOneSystemPrivacyPolicyShow',
      data: {
        systemPrivacyPolicyNO: 'YSTK',
        systemTerminalUserType: 2
      }
    }).then(res => {
      formData.systemPrivacyPolicyContent=  res.data.systemPrivacyPolicyContent
      formData.systemPrivacyPolicyPublicTime=  res.data.systemPrivacyPolicyPublicTime
      formData.systemPrivacyPolicyUpdateTime=  res.data.systemPrivacyPolicyUpdateTime
      formData.systemPrivacyPolicyTitle = res.data.systemPrivacyPolicyTitle
    })

}

// 返回方法
const closeModel = function () {
    // router.go(-1);
  emits('childMethod')
}

// 启动调用
onMounted(() => {
    getOneData();
})

//公开方法
defineExpose({ getOneData });
</script>
<style scoped>
.other_form {
  padding-top: 30px;
  box-sizing: border-box;
}
</style>
